import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './d0f4ef905db6ff4aa2210fbf8d7198de6be0f13a621b3369ac7134651a7e3c08.cfe-internal.js';
import '../Input/8b306eed80472bc167488d029758903f189ea21b58685c7d85ad4a1de9637088.cfe-internal.js';
import Input from '../Input/0313aac0a73c29ca9b860be5ca5b212107cd810318bb0b89176cc766dbf84b47.cfe-internal.js';

var _excluded = ["hex", "swatchColor", "onChange", "className"];
var HEX_REGEX = /#?[a-fA-F0-9]{3,}/;
var HexInput = function HexInput(_ref) {
  var hex = _ref.hex,
    swatchColor = _ref.swatchColor,
    onChange = _ref.onChange,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React__default.useState(hex),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var _React$useState3 = React__default.useState(hex),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    blurValue = _React$useState4[0],
    setBlurValue = _React$useState4[1];
  var inputRef = React__default.useRef(null);
  React__default.useEffect(function () {
    if (hex !== value) {
      if (document.activeElement === inputRef.current) {
        setBlurValue(hex);
      } else {
        setValue(hex);
        setBlurValue(!blurValue && hex);
      }
    }
  }, [blurValue, hex, value]);
  function isValid(val) {
    return HEX_REGEX.test(val);
  }
  function handleChange(e) {
    setValue(e.target.value);
    if (isValid(e.target.value)) {
      onChange === null || onChange === void 0 || onChange(e.target.value, e);
    }
  }
  function handleBlur() {
    if (blurValue) {
      setValue(blurValue);
      setBlurValue(null);
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.hex, className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.hexSwatch
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.alphaCheckerboard, styles.hexSwatchColor)
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.hexSwatchColor,
    style: {
      backgroundColor: swatchColor
    }
  })), /*#__PURE__*/React__default.createElement(Input, _extends({}, rest, {
    ref: inputRef,
    className: styles.hexInput,
    onChange: handleChange,
    onBlur: handleBlur,
    value: value,
    small: true
  })));
};

export { HexInput as default };
